import websitesService from "@/services/websites";
import serviceHandler from "@/helpers/handlers/service";

export default {
  clearFbPostData({ commit }) {
    commit("SET_FB_POST_DATA", null);
  },
  setFbPostData({ commit }, data) {
    commit("SET_FB_POST_DATA", data);
  }
};
